import { MantaBase } from 'site/mantabase';
const _global = (window /* browser */ || global /* node */); // eslint-disable-line @typescript-eslint/no-explicit-any
export class ReCaptcha {
    constructor(formId, tokenInputId) {
        this.manta = new MantaBase();
        this.$form = $(formId);
        this.$tokenInput = $(tokenInputId);
        this.$submitBtn = this.$form.find('button');
        this.init();
    }
    init() {
        let self = this;
        self.$submitBtn.on('click', (e) => {
            e.preventDefault();
            grecaptcha.execute();
        });
        _global.submitPayload = self.submitPayload;
    }
    submitPayload(token) {
        console.log(token);
        $("#recaptcha-token-input").val(token);
        $("#recaptcha-token-input").parent("form").submit();
    }
}
